import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import '../getting-started/HelpCategoryPage.css';

/**
 * Phantom Connect Article Page
 */
const Integration1 = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Phantom Connect</h1>
                <p className="article-subtitle">
                  Use your Google or Apple account to instantly create or access your crypto wallet within the app.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Overview</h2>
                  <p className="article-section-intro">
                    WeSplit leverages Phantom Connect to bridge the gap between Web2 and Web3 by using familiar Single Sign-On (SSO) methods like Google and Apple. This integration eliminates the need for managing complex seed phrases for new users, making your onboarding process instant and secure.
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Key Features</h2>
                </div>

                <div className="article-subsection">
                  <ul className="article-list-dots">
                    <li>
                      <strong>Instant Onboarding:</strong> Create a fully functional Phantom wallet in seconds using just your email.
                    </li>
                    <li>
                      <strong>Familiar Login:</strong> Sign in with your existing Google or Apple accounts.
                    </li>
                    <li>
                      <strong>No Extensions Required:</strong> Access your wallet directly within the WeSplit interface, on any device.
                    </li>
                    <li>
                      <strong>Non-Custodial Security:</strong> Even though you log in with email, you retain full ownership of your assets. Phantom generates and encrypts your keys securely.
                    </li>
                  </ul>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">How It Works</h2>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Choose Your Method:</strong> When the Phantom Connect modal opens on WeSplit, simply select 'Continue with Google' or 'Continue with Apple'.
                    </li>
                    <li>
                      <strong>Authenticate:</strong> Follow the standard login prompt from your chosen provider. No separate password creation is needed for WeSplit.
                    </li>
                    <li>
                      <strong>Wallet Activation:</strong> Phantom automatically spins up a secure embedded wallet for you. You are now ready to split expenses, settle debts, and transact on-chain immediately.
                    </li>
                  </ol>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">For Existing Phantom Users</h2>
                  <p className="article-section-intro">
                    If you already use the Phantom wallet extension or mobile app, WeSplit detects it automatically. You can choose to connect your existing wallet instead of creating a new one via SSO, ensuring all your assets remain in one place.
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Security & Privacy</h2>
                  <p className="article-section-intro">
                    WeSplit does not store your private keys or login credentials. The authentication is handled directly by Phantom's infrastructure, ensuring enterprise-grade security for your digital assets.
                  </p>
                </div>

                <div className="article-subsection">
                  <p>
                    <strong>Learn More:</strong> For deep dives into the technology powering this integration, visit the{' '}
                    <a href="https://phantom.com/connect" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--green)', textDecoration: 'underline' }}>
                      official Phantom Connect documentation
                    </a>.
                  </p>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Integration1;
